import * as React from 'react';
import { Link } from 'gatsby';
import FancyTitle from '../fancy-title';

export default function MeetTeammember({ blok }) {
  const {
    title,
    text,
    listItems,
    listpoints,
    image,
    button,
    buttonText,
  } = blok;

  return (
    <div className="bg-black px-8 lg:px-20 green-background-double py-[70px] text-white flex justify-between flex-col lg:flex-row">
      <div className="w-full flex justify-left xl:justify-center lg:w-7/12 flex flex-col">
        <FancyTitle
          text={title}
          tag="h2"
          className="mb-8"
        />
        {image && (
          <img
            src={image[0].filename}
            alt=""
            className="w-full rounded-full aspect-square block lg:hidden max-w-[400px] m-auto mb-8"
          />
        )}
        <p dangerouslySetInnerHTML={{ __html: text }} />

        {listItems && (
          <p className="mt-8 leading-[3] pl-[16px]" dangerouslySetInnerHTML={{ __html: listItems }} />
        )}
        {listpoints && (
        <ul className="list-disc pl-4 pt-2">
          {listpoints?.content[0].content?.map((listItem) => (
            <li className="py-[8px]">{listItem.content[0].content[0].text}</li>
          ))}
        </ul>
        )}
        <Link to={button.url ? button.url : button.cached_url} className="uppercase button-primary mt-8 w-max">{buttonText}</Link>
      </div>
      {image && (
        <div className="w-full lg:w-4/12">
          <img
            src={image[0].filename}
            alt=""
            className="w-full rounded-full aspect-square hidden lg:block"
          />
        </div>
      )}
    </div>
  );
}
